module.exports = __webpack_public_path__ + "dimer/static/img/discoveryIconGroup.ae3eda5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discoveryIconGroup.png
// module id = cJc+
// module chunks = 0